import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "forward",
  "use": "forward-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"forward\"><path fill=\"#555353\" fill-rule=\"evenodd\" d=\"M8 4V0l8 8-8 8v-4H0V4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol